import type { ContextItem } from '@/components/momento/MomentoContextBlock';

function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

function formatPostTitle(postTitle?: string | null, postCreatedAt?: string | null): string {
  if (!postTitle) return 'Unknown video';
  if (!postCreatedAt) return postTitle;
  try {
    const date = new Date(postCreatedAt);
    const dateStr = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined,
    });
    return `${postTitle} (${dateStr})`;
  } catch {
    return postTitle;
  }
}

export function buildContextItems(selectedMoment: any, activeMemo: any): ContextItem[] {
  const items: ContextItem[] = [];
  if (selectedMoment) {
    const isFullVideo =
      selectedMoment.momentType === 'full_video' ||
      (selectedMoment.startTime === 0 && selectedMoment.endTime === 0);
    const duration = selectedMoment.endTime - selectedMoment.startTime;
    items.push({
      type: 'selectedMoment',
      title: selectedMoment.title || (isFullVideo ? 'Full Video' : 'Untitled moment'),
      subtitle: `From "${selectedMoment.postTitle || 'Unknown video'}"`,
      details: isFullVideo
        ? [{ label: 'Type', value: 'Full Video' }]
        : [
            { label: 'Time', value: `${formatTime(selectedMoment.startTime)} - ${formatTime(selectedMoment.endTime)}` },
            { label: 'Duration', value: `${duration.toFixed(1)}s` },
          ],
    });
  }
  if (activeMemo) {
    const cuts = activeMemo.edit_plan?.cuts?.length || 0;
    const captions = activeMemo.edit_plan?.captions?.length || 0;
    const duration = activeMemo.source_timerange.end - activeMemo.source_timerange.start;
    items.push({
      type: 'activeMemo',
      title: activeMemo.title,
      subtitle: `From "${formatPostTitle(activeMemo.postTitle, activeMemo.postCreatedAt)}"`,
      details: [
        {
          label: 'Edits',
          value:
            cuts > 0 || captions > 0
              ? `${cuts} cut${cuts !== 1 ? 's' : ''}, ${captions} caption${captions !== 1 ? 's' : ''}`
              : 'No edits yet',
        },
        { label: 'Duration', value: `${duration.toFixed(1)}s` },
      ],
    });
  }
  return items;
}
